import axios from 'axios';

import {authHeader} from '../helpers/auth.helper';

export const SIGNIN_USUARIO = 'SIGNIN_USUARIO';
export const SIGNIN_USUARIO_SUCCESS = 'SIGNIN_USUARIO_SUCCESS';
export const SIGNIN_USUARIO_FAILURE = 'SIGNIN_USUARIO_FAILURE';

export const LOGOUT_USER = 'LOGOUT_USER';

export const FETCH_USUARIO = 'FETCH_USUARIO';
export const FETCH_USUARIO_SUCCESS = 'FETCH_USUARIO_SUCCESS';
export const FETCH_USUARIO_FAILURE = 'FETCH_USUARIO_FAILURE';

export const FETCH_USUARIOS = 'FETCH_USUARIOS';
export const FETCH_USUARIOS_SUCCESS = 'FETCH_USUARIOS_SUCCESS';
export const FETCH_USUARIOS_FAILURE = 'FETCH_USUARIOS_FAILURE';

export const DELETE_USUARIO_SUCCESS = 'DELETE_USUARIO_SUCCESS';
export const DELETE_USUARIO_FAILURE = 'DELETE_USUARIO_FAILURE';

export const CREATE_USUARIO_SUCCESS = 'CREATE_USUARIO_SUCCESS';
export const CREATE_USUARIO_FAILURE = 'CREATE_USUARIO_FAILURE';

export const UPDATE_USUARIO_SUCCESS = 'UPDATE_USUARIO_SUCCESS';
export const UPDATE_USUARIO_FAILURE = 'UPDATE_USUARIO_FAILURE';

const ROOT_URL = 'https://api.monitor-backup.suprasys.com.br';
//const ROOT_URL = 'http://168.138.128.21:8891';
//const ROOT_URL = 'http://localhost:8891';

export function signInUser(login, senha) {
    return (dispatch) => {
        dispatch(signInUserLoading());

        const payload = JSON.stringify({login, senha});

        let config = {
            headers: {'Content-Type': 'application/json'}
        };

        return axios.post(`${ROOT_URL}/login`, payload, config)
            .then(response => {
                let headers = response.headers;
                let token = headers.authorization.substr(7); // "Bearer " = 7 chars

                localStorage.setItem('token', token);

                dispatch(signInUserSuccess());
            })
            .catch(error => dispatch(signInUserFailure(error)))
    }
}

export function signInUserLoading() {
    return {
        type: SIGNIN_USUARIO,
    };
}

export function signInUserSuccess(token) {
    return {
        type: SIGNIN_USUARIO_SUCCESS,
        payload: token
    };
}

export function signInUserFailure(error) {
    return {
        type: SIGNIN_USUARIO_FAILURE,
        payload: error
    };
}

export function signOutUser() {
    localStorage.removeItem('token');

    return {
        type: LOGOUT_USER
    };
}

export function fetchUsuario(id) {
    return (dispatch) => {
        dispatch(fetchUsuarioLoading());

        let config = {
            headers: authHeader()
        };

        axios.get(`${ROOT_URL}/usuarios/${id}`, config)
            .then(response => dispatch(fetchUsuarioSuccess(response)))
            .catch(error => dispatch(fetchUsuarioFailure(error)));
    }
}

export function fetchUsuarioLoading() {
    return {
        type: FETCH_USUARIO
    }
}

export function fetchUsuarioSuccess(response) {
    return {
        type: FETCH_USUARIO_SUCCESS,
        payload: response.data
    };
}

export function fetchUsuarioFailure(error) {
    return {
        type: FETCH_USUARIO_FAILURE,
        payload: error
    }
}


export function fetchUsuarios() {
    return (dispatch) => {
        dispatch(fetchUsuariosLoading());

        let config = {
            headers: authHeader()
        };

        axios.get(`${ROOT_URL}/usuarios`, config)
            .then(response => dispatch(fetchUsuariosSuccess(response)))
            .catch(error => dispatch(fetchUsuariosFailure(error)));
    }
}

export function fetchUsuariosLoading() {
    return {
        type: FETCH_USUARIOS
    }
}

export function fetchUsuariosSuccess(response) {
    return {
        type: FETCH_USUARIOS_SUCCESS,
        payload: response.data
    };
}

export function fetchUsuariosFailure(error) {
    return {
        type: FETCH_USUARIOS_FAILURE,
        payload: error
    }
}

export function deleteUsuario(id) {
    return (dispatch) => {
        let config = {
            headers: authHeader()
        };

        axios.delete(`${ROOT_URL}/usuarios/${id}`, config)
            .then(response => {
                dispatch(deleteUsuarioSuccess(response));
                dispatch(fetchUsuarios());
            })
            .catch(error => dispatch(deleteUsuarioFailure(error)));
    }
}

export function deleteUsuarioSuccess(response) {
    return {
        type: DELETE_USUARIO_SUCCESS,
        payload: response.data
    };
}

export function deleteUsuarioFailure(error) {
    return {
        type: DELETE_USUARIO_FAILURE,
        payload: error
    }
}

export function createUsuario(usuario) {
    return (dispatch) => {
        let config = {
            headers: authHeader()
        };

        axios.post(`${ROOT_URL}/usuarios`, usuario, config)
            .then(response => {
                dispatch(createUsuarioSuccess(response));
                dispatch(fetchUsuarios());
            })
            .catch(error => dispatch(createUsuarioFailure(error)));
    }
}

export function createUsuarioSuccess(response) {
    return {
        type: CREATE_USUARIO_SUCCESS,
        payload: response.data
    }
}

export function createUsuarioFailure(error) {
    return {
        type: CREATE_USUARIO_FAILURE,
        payload: error
    }
}

export function updateUsuario(usuario) {
    return (dispatch) => {
        let config = {
            headers: authHeader()
        };

        axios.put(`${ROOT_URL}/usuarios/${usuario.id}`, usuario, config)
            .then(response => {
                dispatch(updateUsuarioSuccess(response));
                dispatch(fetchUsuarios());
            })
            .catch(error => dispatch(updateUsuarioFailure(error)));
    }
}

export function updateUsuarioSuccess(response) {
    return {
        type: UPDATE_USUARIO_SUCCESS,
        payload: response.data
    }
}

export function updateUsuarioFailure(error) {
    return {
        type: UPDATE_USUARIO_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// src/actions/usuario.js